import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "modal-actions" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Commissioning report")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "Select a turbine to generate a report of its sensors and when each came online.", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Turbine", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAsset) = $event)),
                class: "form-select"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, "Select turbine", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: asset,
                    value: asset
                  }, _toDisplayString(asset), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedAsset]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                disabled: _ctx.generating,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
              }, _toDisplayString(_ctx.generating ? "Generating..." : "Generate report"), 9, _hoisted_9)
            ])
          ]))
    ])
  ]))
}